import { Outlet, useLocation } from 'react-router-dom'
import { PageTitle } from './PageTitle'

/**
 * Broker chrome: page title + content only.
 * Dashboard / Accounts own their own account context — no global Demo KPI strip.
 * Trading History keeps title inside the page so controls sit tight under the heading.
 */
export function WorkspaceChrome() {
  const location = useLocation()
  const path = location.pathname.replace(/\/+$/, '') || '/'
  const isDashboard = path === '/app'
  const isTradeDesk = path.startsWith('/app/trade')
  const titleInPage =
    path.startsWith('/app/trading-history') ||
    path.startsWith('/app/withdrawals') ||
    path.startsWith('/app/deposits') ||
    path.startsWith('/app/support') ||
    path.startsWith('/app/profile') ||
    isTradeDesk

  return (
    <div
      className={`cp-workspace${isDashboard ? ' cp-workspace--dash' : ''}${
        titleInPage ? ' cp-workspace--tight' : ''
      }${isTradeDesk ? ' cp-workspace--trade' : ''}`}
    >
      {titleInPage ? null : <PageTitle />}
      <div className="cp-workspace__content">
        <Outlet />
      </div>
    </div>
  )
}
